import { useState, useEffect, useMemo } from 'react';
import { getSyncQueue } from '@/lib/syncQueue';

export function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [queue, setQueue] = useState(getSyncQueue());

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Monitor local storage for queue changes (from other tabs)
    const handleStorage = (e: StorageEvent) => {
      if (e.key === 'team-v-does-sync-queue') {
        setQueue(getSyncQueue());
      }
    };
    window.addEventListener('storage', handleStorage);

    // Periodic check for queue count if updated in same tab
    const interval = setInterval(() => {
        setQueue(getSyncQueue());
    }, 2000);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('storage', handleStorage);
      clearInterval(interval);
    };
  }, []);

  const pendingCount = queue.length;

  // Extract task IDs that have pending sync effects
  const pendingSyncTaskIds = useMemo(() => {
    const ids = new Set<string>();
    for (const effect of queue) {
      const taskId = effect.payload?.taskId;
      if (taskId) ids.add(taskId);
    }
    return ids;
  }, [queue]);

  return { isOnline, pendingCount, pendingSyncTaskIds };
}
